<template>
    <div id="filterRow">
        <div class="filterBar">
            <DisplayOptionsMenu
                :preferences="preferences"
                :viewOptions="viewOptions"
                :areWorkSchedulesEnabled="areWorkSchedulesEnabled"
                @update:viewOptions="emitUpdateViewOptions"
                @update:preference="emitUpdatePreference"
                @open:themeSettings="$emit('open:themeSettings')"
            />
            <RosterActionsMenu
                :globals="globals"
                :roster="roster"
                :permissions="permissions"
                :allowRosterActionsToAnyWeekDay="allowRosterActionsToAnyWeekDay"
                @reload:roster="$emit('reload:roster')"
                @rosterProposed="$emit('rosterProposed', $event)"
                @rosterPublished="$emit('rosterPublished', $event)"
            />
            <ContractHoursOptionsMenu
                :showPlusMinusBalanceFrom="showPlusMinusBalanceFrom"
                :rosterViewSettings="rosterViewSettings"
                @update:showPlusMinusBalancesFrom="$emit('update:showPlusMinusBalancesFrom', $event)"
            />
            <DeploymentCounterOptionsMenu
                :showDeploymentCounterFrom="showDeploymentCounterFrom"
                :rosterViewSettings="rosterViewSettings"
                @update:showDeploymentCounterFrom="$emit('update:showDeploymentCounterFrom', $event)"
            />
            <VisibleBalancesMenu
                :enabledBalanceFilters="enabledBalanceFilters"
                :leaveOverviews="leaveOverviews"
                :timeTypes="roster.timeTypes"
                :deploymentCountConfigurations="deploymentCountConfigurations"
                @update:enabledBalanceFilters="$emit('update:enabledBalanceFilters', $event)"
            />

            <div class="menu-link link-legend">
                <div class="label" @click="$emit('legend:show')">Toon Legenda</div>
            </div>

        </div>
        <RosterOpenedBy :rosterViewSettings="rosterViewSettings" />
        <OptionsAndFilterCollapser />
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import DisplayOptionsMenu from '@/components/FilterBar/DisplayOptionsMenu.vue';
    import RosterActionsMenu from '@/components/FilterBar/RosterActionsMenu.vue';
    import ContractHoursOptionsMenu from '@/components/FilterBar/ContractHoursOptionsMenu.vue';
    import DeploymentCounterOptionsMenu from '@/components/FilterBar/DeploymentCounterOptionsMenu.vue';
    import VisibleBalancesMenu from '@/components/FilterBar/VisibleBalancesMenu.vue';
    import RosterOpenedBy from '@/components/FilterBar/RosterOpenedBy.vue';
    import OptionsAndFilterCollapser from '@/components/Planbord/OptionsAndFilterCollapser.vue';
    import {ViewOptions, RosterData, PermissionsForRoster} from '@/types/types';
    import {DeploymentCounterStart, BalanceFilterEnabled} from '@/components/FilterBar/types';
    import {RosterViewSettings} from '@/types';
    import {Globals, LeaveOverview, DeploymentCountConfiguration} from '@cquential/api';

    @Component({
        components: {
            DisplayOptionsMenu,
            RosterActionsMenu,
            ContractHoursOptionsMenu,
            DeploymentCounterOptionsMenu,
            VisibleBalancesMenu,
            RosterOpenedBy,
            OptionsAndFilterCollapser,
        },
        emits: [
            'update:preference',
            'update:viewOptions',
            'update:enabledBalanceFilters',
            'update:showPlusMinusBalancesFrom',
            'update:showDeploymentCounterFrom',
            'reload:roster',
            'rosterProposed',
            'rosterPublished',
            'legend:show',
            'open:themeSettings',
        ],
    })
    export default class FilterBar extends Vue {
        @Prop({required: true}) public viewOptions!: ViewOptions;
        @Prop({required: true}) public globals!: Globals;
        @Prop({required: true}) public showPlusMinusBalanceFrom!: Date | false;
        @Prop({required: true}) public showDeploymentCounterFrom!: DeploymentCounterStart;
        @Prop({required: true}) public rosterViewSettings!: RosterViewSettings;
        @Prop({required: true}) public roster!: RosterData;
        @Prop({required: true}) public preferences!: Record<string, string | number>;
        @Prop({required: true}) public permissions!: PermissionsForRoster;
        @Prop({required: true}) public enabledBalanceFilters!: Record<string, BalanceFilterEnabled>;
        @Prop({required: true}) public leaveOverviews!: LeaveOverview[];
        @Prop({required: true}) public deploymentCountConfigurations!: DeploymentCountConfiguration[];
        @Prop({type: Boolean}) public allowRosterActionsToAnyWeekDay!: boolean;
        @Prop({type: Boolean}) public areWorkSchedulesEnabled!: boolean;

        private emitUpdatePreference(preference: string, value?: number | string | boolean): void {
            this.$emit('update:preference', preference, value);
        }

        private emitUpdateViewOptions<K extends keyof ViewOptions>(option: K, value?: ViewOptions[K]): void {
            this.$emit('update:viewOptions', option, value);
        }
    }
</script>

<style lang="scss" scoped>
    #filterRow {
        height: var(--filterrow-height);
        margin: 0 15px;
        display: flex;
        justify-content: space-between;

        .filterBar {
            height: var(--filterrow-height);
            background: var(--filter-bar-background);
            color: var(--theme-text-color);
            box-shadow: var(--generic-shadow-subtle);
            border-radius: var(--theme-border-radius);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-align: right;
            padding: 1rem;
        }

        .link-legend {
            margin-left: 1rem;

            .label {
                cursor: pointer;
            }
        }
    }
</style>
